import { useEffect, useState } from 'react';
import { SuperAdminSidebar } from '../../components/Sidebar';
import api from '../../utils/api';

export default function ActivityLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/superadmin/activity-logs').then(r => setLogs(r.data.logs)).finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ display: 'flex' }}>
      <SuperAdminSidebar />
      <main className="main-content">
        <h1 style={{ fontSize: 28, marginBottom: 24 }}>Aktivitätsprotokoll</h1>
        <div className="card">
          {loading ? <div className="spinner-wrap"><div className="spinner"/></div> : (
            <div className="table-wrap">
              <table>
                <thead><tr><th>Aktion</th><th>Moschee</th><th>Benutzer</th><th>Zeit</th></tr></thead>
                <tbody>
                  {logs.map(l => (
                    <tr key={l.id}>
                      <td style={{fontFamily:'monospace',fontSize:13}}>{l.action}</td>
                      <td style={{color:'var(--text2)'}}>{l.mosque_name||'—'}</td>
                      <td style={{color:'var(--text3)',fontSize:13}}>{l.user_email||'—'}</td>
                      <td style={{color:'var(--text3)',fontSize:12}}>{new Date(l.created_at).toLocaleString('de-CH')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
